module.exports = __webpack_public_path__ + "img/us.8bcb519.jpg";